import { render, staticRenderFns } from "./LSelect2.vue?vue&type=template&id=ddb964b8"
import script from "./LSelect2.vue?vue&type=script&lang=js"
export * from "./LSelect2.vue?vue&type=script&lang=js"
import style0 from "./LSelect2.vue?vue&type=style&index=0&id=ddb964b8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports